









import { Component, Vue, Prop } from "vue-property-decorator";
import { JobItem, JobHistoryItem } from "../common/interfaces";
import Store from "@/store/store";
import moment from "moment";
import axios from "axios";
import PastJob from "../components/JobSearches/PastJob.vue";

@Component({
  components: {
    PastJob
  }
})
export default class JobHistory extends Vue {
  protected jobHistory: JobHistoryItem[] = [];
  protected loadingJobs: boolean = false;

  public created() {
    this.getjobHistory();
    this.$root.$on("refreshJobList", this.getjobHistory);
  }

  protected async getjobHistory() {
    this.loadingJobs = true;
    this.jobHistory = [];
    const response = await axios.get(
      `${Store.state.Environment.ODataBaseUrl}/Problems?$select=ProblemId,Description,Type1Id,StatusId,StatusFlag,ProblemActionLogs` +
        `&$expand=ProblemXtra($select=EngineerCode,BookedInDateTime),` +
        `Contact($select=ContactId;$expand=Division($select=Name;$expand=Company($select=Name)),` +
        `Address($select=AddressLine4,Postcode)),Inventory($select=InventoryId;` +
        `$expand=InventoryXtra($select=NextVisitDate)` +
        `,Division($select=DivisionId,Name;$expand=Address($select=AddressId,Postcode)` +
        `,Company($select=CompanyId,Name)))` +
        `,Status($select=Description),` +
        `Type1($select=Description),ProblemActionLogs($select=ActionDate;` +
        `$filter=FromStatusId eq 'ENGINR' and ToStatusId eq 'COMPLT')&$filter=StatusId eq 'COMPLT' ` +
        `and StatusFlag eq 'A' and ProblemXtra/EngineerCode eq '${Store.state.User.UserCode}' and ` +
        `ProblemActionLogs/any(pal: pal/FromStatusId eq 'ENGINR' and pal/ToStatusId eq 'COMPLT' ` +
        `and ${this.createDateFilter("pal/ActionDate")})`,
      {
        headers: {
          Authorization: "Bearer " + Store.state.User.AccessToken
        }
      }
    );

    if (response.status === 200 && response.data) {
      const jobs = response.data.value;

      jobs.forEach((j: any) => {
        const lastStatusChange: any = j.ProblemActionLogs.sort(
          (a: any, b: any): number => {
            const firstDate = moment(a.ActionDate);
            const secondDate = moment(b.ActionDate);

            if (!firstDate.isValid()) {
              return -1;
            } else if (!secondDate.isValid()) {
              return 1;
            } else {
              return secondDate.diff(firstDate);
            }
          }
        )[0].ActionDate;

        const job: JobHistoryItem = {
          JobId: j.ProblemId,
          JobDescription: j.Description,
          JobType: j.Type1Id,
          TypeDescription: j.Type1.Description,
          StatusId: j.StatusId,
          StatusFlag: j.StatusFlag,
          EngineerCode: j.ProblemXtra.EngineerCode,
          BookedInDateTime: j.ProblemXtra.BookedInDateTime
            ? moment(j.ProblemXtra.BookedInDateTime)
            : undefined,
          DivisionName: j.Inventory ? j.Inventory.Division.Name : null,
          CompanyName: j.Inventory ? j.Inventory.Division.Company.Name : null,
          AddressPostcode: j.Inventory? j.Inventory.Division.Address.Postcode : null,
          NextVisitDate: moment(j.Inventory.InventoryXtra.NextVisitDate),
          LastStatus: j.Status.Description,
          StatusChangeTime: moment(lastStatusChange)
        };

        this.jobHistory.push(job);
      });
      this.loadingJobs = false;
    }
  }

  get sortedJobHistory() {
    return this.jobHistory.sort(
      (a: JobHistoryItem, b: JobHistoryItem): number => {
        if (!b.BookedInDateTime || !b.StatusChangeTime!.isValid()) {
          return 1;
        } else if (!a.BookedInDateTime || !a.StatusChangeTime!.isValid()) {
          return -1;
        } else {
          return b.StatusChangeTime!.diff(a.StatusChangeTime);
        }
      }
    );
  }

  private createDateFilter(field: string) {
    // add 1 day to start on monday
    const startOfHistory = moment()
      .startOf("day")
      .subtract(2, "weeks");
    const endOfHistory = moment()
      .startOf("day")
      .add(1, "days");
    return `${field} ge ${startOfHistory.toISOString()} and ${field} lt ${endOfHistory.toISOString()}`;
  }
}
